import i18next from 'i18next';
import * as Yup from 'yup';
import { timeStringToSeconds } from '../timeStringToSeconds';

const useTrimVideoValidation = () => {
  return Yup.object({
    startTime: Yup.string()
      .required(i18next.t('pages:library.trimLibraryVideo.errors.startTimeRequired'))
      .test(
        'start-not-equal-end',
        i18next.t('pages:library.trimLibraryVideo.errors.startTimeAndEndTimeEqual'),
        function (value: string | undefined) {
          const { endTime } = this.parent;
          if (!value || !endTime) return true;
          return timeStringToSeconds(value) !== timeStringToSeconds(endTime);
        }
      )
      .test(
        'start-before-end',
        i18next.t('pages:library.trimLibraryVideo.errors.startTimeAfterEndTime'),
        function (value: string | undefined) {
          const { endTime } = this.parent;
          if (!value || !endTime) return true;
          return timeStringToSeconds(value) < timeStringToSeconds(endTime);
        }
      ),
    endTime: Yup.string()
      .required(i18next.t('pages:library.trimLibraryVideo.errors.endTimeRequired'))
      .test(
        'end-not-equal-start',
        i18next.t('pages:library.trimLibraryVideo.errors.startTimeAndEndTimeEqual'),
        function (value: string | undefined) {
          const { startTime } = this.parent;
          if (!value || !startTime) return true;
          return timeStringToSeconds(value) !== timeStringToSeconds(startTime);
        }
      )
      .test(
        'end-after-start',
        i18next.t('pages:library.trimLibraryVideo.errors.startTimeAfterEndTime'),
        function (value: string | undefined) {
          const { startTime } = this.parent;
          if (!value || !startTime) return true;
          return timeStringToSeconds(value) > timeStringToSeconds(startTime);
        }
      ),
    isTrimmed: Yup.boolean().test('no-changes', function (value: boolean | undefined) {
      const { isDeletingUnusedContent } = this.parent;
      return value || isDeletingUnusedContent;
    }),
  });
};

export default useTrimVideoValidation;
